import React from 'react';
import './ContactPage.css';
import AboutProduct from './AboutProduct';

export default function ContactPage() {
    return (
        <React.Fragment>
            <AboutProduct/>
        </React.Fragment>
    )
}
